import { useState } from 'react';

import './App.css';
import Game from "./components/game/game.component";

export default function App() {
    return (
        <Game/>
    )
}